// src/store/modules/home.js
import { getcommonData } from "@api/home";
const state = {
    datalist: [] // 初始数据
};

const getters = {
    datalist: (state) => state.datalist // 返回数据列表
};

const mutations = {
    setDatalist(state, data) {

        state.datalist = data; // 更新数据列表
    }
};

const actions = {
    async fetchDatalist({ commit }) {
        try {
            // 调用 API 函数获取数据
            const response = await getcommonData(); // 假设这个函数返回一个 Promise
            const data = response.data; // 假设返回的数据在 response.data 中

            commit('setDatalist', data); // 提交 mutation 更新状态
        } catch (error) {
            console.error('获取数据失败:', error); // 处理错误
        }
    }
};

export default {
    namespaced: true, // 确保模块是命名空间的
    state,
    getters,
    mutations,
    actions
};